module.exports = __webpack_public_path__ + "e94f662476fd67c4b36322cfeca5b4c3.m4a";